import {
	Component,
	OnInit,
	forwardRef,
	AfterViewInit,
	OnDestroy
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { CtaButtonGroupComponent } from "../../cta-button-group/cta-button-group.component";
import { CtaButtonFeaturesGroupComponent } from "../../cta-button-features-group/cta-button-features-group.component";
import { CtaToggleButtonGroupComponent } from "../cta-toggle-button-group/cta-toggle-button-group.component";

@Component({
    selector: "dodo-cta-toggle-button-group-control",
    templateUrl: "./cta-toggle-button-group-control.component.html",
    styleUrls: ["./cta-toggle-button-group-control.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CtaToggleButtonGroupControlComponent),
            multi: true
        }
    ],
    standalone: false
})
export class CtaToggleButtonGroupControlComponent
	implements OnInit, ControlValueAccessor, AfterViewInit, OnDestroy {
	private __buttonGroup: CtaToggleButtonGroupComponent;
	private __featuresGroup: CtaButtonFeaturesGroupComponent;

	_activeButtonId: string | number;

	_disabled = false;

	set activeButtonId(id: string | number) {
		if (this._activeButtonId !== id) {
			this._activeButtonId = id;
			this.propagateChange(this._activeButtonId);
		}
	}

	get activeButtonId(): string | number {
		return this._activeButtonId;
	}

	constructor() {}

	// * -----------------------------------------------------------------------------
	// * Interfaces
	// * -----------------------------------------------------------------------------
	ngOnInit() {}

	// #
	// #
	// # AfterViewInit Interface

	ngAfterViewInit(): void {
		// throw new Error("Method not implemented.");
	}

	// #
	// #
	// # OnDestroy interface

	ngOnDestroy(): void {
		// throw new Error("Method not implemented.");
	}

	// #
	// #
	// # Control Value Accessor interface
	propagateChange = (_: any) => {};

	writeValue(activeButtonId: string | number): void {
		if (activeButtonId !== undefined || activeButtonId !== null) {
			this._activeButtonId = activeButtonId;

			if (this.__buttonGroup) {
				this.__buttonGroup.activeButtonId = this._activeButtonId;
			}
		}
	}

	registerOnChange(fn: any): void {
		this.propagateChange = fn;
	}

	registerOnTouched(fn: any): void {
		// throw new Error("Method not implemented.");
	}

	setDisabledState?(isDisabled: boolean): void {
		this._disabled = isDisabled;
		// throw new Error("Method not implemented.");
	}

	// * -----------------------------------------------------------------------------
	// * Interfaces
	// * -----------------------------------------------------------------------------

	public registerButtonGroup(buttonGroup: CtaToggleButtonGroupComponent) {
		this.__buttonGroup = buttonGroup;

		this.__buttonGroup.buttonClicked.subscribe(
			(buttonId: string | number) => {
				this.activeButtonId = buttonId;
			}
		);

		if (
			this._activeButtonId !== undefined &&
			this._activeButtonId !== null
		) {
			this.__buttonGroup.activeButtonId = this._activeButtonId;
		}
	}
}
